import { render, staticRenderFns } from "./OmniChatContainer.vue?vue&type=template&id=bfe5f1fa&scoped=true"
import script from "./OmniChatContainer.vue?vue&type=script&lang=js"
export * from "./OmniChatContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe5f1fa",
  null
  
)

export default component.exports